<template>
    
    <div>

        <v-dialog
            v-model="tagPopup"
            width="500"
            >
            <v-card outlined>

                <v-tabs v-model="popupTabs">
                    <v-tab>{{ $t("Tag") }}</v-tab>
                    <v-tab>{{ $t("Edit") }}</v-tab>
                    <v-tab v-if="selectedTag.is_alarm == 1">{{ $t("Notifications") }}</v-tab>

                </v-tabs>

                <v-divider class="mb-6"></v-divider>

                <v-card-text class="pa-4 pt-0" v-if="popupTabs == 0">

                    <v-row>
                        <v-col cols='3'>ID:</v-col>
                        <v-col>{{ selectedTag.id }}</v-col>                        
                    </v-row>

                    <v-row>
                        <v-col cols='3'>{{ $t("Value") }}:</v-col>
                        <v-col>{{ get_tagValue(selectedTag)  }}</v-col>                        
                    </v-row>

                    <v-row>
                        <v-col cols='3'>{{ $t("Address") }}:</v-col>
                        <v-col>{{ selectedTag.address  }}</v-col>                        
                    </v-row>

                    <v-divider v-if="selectedTag.logging" class="mb-4 mt-4" />

                    <ExportComponent v-if="selectedTag.logging" :selectedTag="selectedTag" />  

                    <v-btn 
                    v-if="selectedTag.logging"
                    text
                    @click="openChart(selectedTag)">
                        <v-icon class="mr-3">mdi-chart-timeline-variant</v-icon>
                        <span>{{ $t("Open chart") }}</span>
                    </v-btn>
                    
                    <span v-if="setpointButton">
                        <updateSetpoint :selectedTag="selectedTag" />  
                    </span>
                
                </v-card-text>
                
                <v-card-text class="pa-4 pb-0" v-if="popupTabs == 1">

                    <v-text-field
                        :label="$t('Name')"
                        outlined
                        v-model="selectedTag.name"
                        v-on:keyup.enter="saveTag();"
                    ></v-text-field>

                    <v-textarea
                        :label="$t('Description')"
                        outlined
                        v-model="selectedTag.description"
                    ></v-textarea>

                    <v-select
                        v-if="selectedTag.is_alarm != 1"
                        v-model="selectedTag.unit"
                        :items="unitTypes"
                        :label="$t('Select unit type')"
                        outlined
                        clearable
                    ></v-select>
                    
                </v-card-text>

                <v-card-text class="pa-4 pt-0" v-if="popupTabs == 2">
                    
                    <v-select
                        v-model="selectedTag.alarm_prio"
                        :items="tagPrios"
                        :label="$t('Prio')"
                        outlined
                        clearable
                    ></v-select>
                    
                    <v-text-field
                        :label="$t('SMS numbers. Seperated by ,')"
                        outlined
                        v-model="selectedTag.sms_numbers"
                        v-on:keyup.enter="saveTag();"
                    ></v-text-field>

                    <v-text-field
                        :label="$t('E-mail addresses. Seperated by ,')"
                        outlined
                        v-model="selectedTag.email_addresses"
                        v-on:keyup.enter="saveTag();"
                    ></v-text-field>

                    <v-text-field
                        :label="$t('Call numbers. Seperated by ,')"
                        outlined
                        v-model="selectedTag.call_numbers"
                        v-on:keyup.enter="saveTag();"
                    ></v-text-field>

                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions color="grey" class="pb-4 pt-4" v-if="popupTabs > 0">

                    <v-btn :loading="loading.saveTag" depressed class="mx-2" color="primary" @click="saveTag();">{{ $t("Save") }}</v-btn>
                    <v-btn outlined class="mx-2" @click.stop="tagPopup = false">{{ $t("Cancel") }}</v-btn>

                </v-card-actions>

            </v-card>

        </v-dialog>

        <Visuals :device="device" v-if="!hide_visuals" />
        
        <div class="pl-4" v-if="action != 'select'">

            <v-switch
            v-model="loggingOnly"
            :label="$t('Logging tags only')"
            ></v-switch>

        </div>

        <v-tabs v-model="tabs">
            <v-tab>{{ $t("Tags") }} <span v-if="!loggingOnly">({{ tags.length }})</span></v-tab>
            <v-tab v-if="alarms.length > 0 ">{{ $t("Alarms") }} <span v-if="!loggingOnly">({{ alarms.length }})</span></v-tab>
        </v-tabs>

        <div v-if="tabs == 0">

            <v-card outlined tile v-for="tag in tags" :key="tag.id" v-bind:class="{ hideTag: isTagHidden(tag) }" @click="selectTag(tag);">

                <div>
                    <div
                    class="d-flex pa-2 align-center"
                    
                    >
                        {{tag.name}}

                        <v-spacer></v-spacer>

                        <div class="mr-2">
                            {{ get_tagValue(tag) }}
                        </div>

                        <v-btn icon>
                            <v-icon>mdi-chevron-right</v-icon>
                        </v-btn>

                    </div>
                    
                </div>

            </v-card>

        </div>

        <div v-if="tabs == 1">

            <v-card outlined tile v-for="alarm in alarms" :key="alarm.id" @click="selectTag(alarm);" v-bind:class="{ hideTag: isTagHidden(alarm) }">

                <div class="d-flex pa-2 align-center" v-bind:class="{ activeAlarm: alarm.value == 1 }">

                    {{alarm.name}}

                    <v-spacer></v-spacer>

                    <div class="mr-2">
                        {{ get_tagValue(alarm) }}
                    </div>

                    <v-btn icon>
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                    
                </div>

            </v-card>

        </div>


    </div>

</template>

<style scoped>

.activeAlarm {
    color: red;
}

.hideTag {
    display: none;
}

</style>

<script>

    import { mapGetters } from "vuex";


    import helpers from "@/helpers";
    import Visuals from '@/apps/ijskoud/components/Visuals.vue' ;
    import tagsApi from "@/api/tags/Tag" ;
    import ExportComponent from '@/components/export/ExportData' ;
    import updateSetpoint from '@/components/devices/updateSetpoint' ;
    import currentUserApi from "@/api/currentuser/CurrentUser" ;

    export default {
        name: "Tags",
        computed: {
            // map `this.user` to `this.$store.getters.user`
            ...mapGetters({
                appData: "app/data",
                devices: "reporters/devices",
            })
        },
        props: {
            device_id: {
                type: Number,
                required: true
            },
            hide_visuals: {
                type: Boolean,
                required: false,
                default: false
            },
            action: {
                type: String,
                required: false,
                default: 'openPopup'
            },
            loggingOnly: {
                type: Boolean,
                required: false,
                default: false
            },


        },
        components: {
            Visuals,
            ExportComponent,
            updateSetpoint,
        },
        data () {
            return {
                tags: [],
                alarms: [],
                tagPopup: false,
                device: null,
                selectedTag: {
                },
                loading: {
                    saveTag: false 
                },
                setpointButton: false,
                unitTypes: [],
                tagPrios: [1,2],
                tabs: 0,
                popupTabs: 0,
                tagExport : false
            }
        },
        methods: {

            get_tagValue(tag){
                return helpers.get_tagValue(tag) ;
            },
            saveTag(){

                let _this = this ;

                this.loading.saveTag = true ;
                this.selectedTag.device_id = this.device_id ; 

                if(this.selectedTag.is_alarm == 1){
                    this.selectedTag.type = 'alarms' ; 
                }else{
                    this.selectedTag.type = 'tags' ; 
                }
                
                let api = new tagsApi() ;
                
                api.save_settings(this.selectedTag).then(function(data) {

                    // success
                    _this.loading.saveTag = false ;
                    console.log(data);


                })
                .catch(errorMessage => {

                    _this.loading.saveTag = false ;
                    console.log(errorMessage);
                    
                });
                
            },
            selectTag(tag){

                if(this.action == 'select'){

                    tag.device_id = this.device.id ;

                    this.$store.commit('app/setSelectedTag', tag);
                    
                }else{

                    let _this = this ; 

                    this.popupTabs = 0 ; 
                    this.selectedTag = tag ;

                    if(!this.selectedTag.sms_numbers){ this.selectedTag.sms_numbers = ''; }
                    if(!this.selectedTag.email_addresses){ this.selectedTag.email_addresses = ''; }
                    if(!this.selectedTag.call_numbers){ this.selectedTag.call_numbers = ''; }
                    if(!this.selectedTag.unit){ this.selectedTag.unit = ''; }

                    if(this.selectedTag.is_alarm == 1 && typeof this.selectedTag.alarm_prio == undefined){

                        this.selectedTag.alarm_prio = 2 ; 

                    }

                    this.selectedTag.rights = 'read' ;
                    this.selectedTag.device = this.device ;

                    this.tagPopup = true ;
                    
                    if(this.selectedTag.is_setpoint == '1'){

                        let api = new currentUserApi() ;

                        api.hasRights('tag', this.selectedTag.id, 'read_write')
                        .then(right => {

                            if(right){
                                _this.setpointButton = true ;
                            }

                        });
                        
                    }else{
                        _this.setpointButton = false ;
                    }
                    
                }
                
            },
            openChart(tag){
                
                this.$store.commit("app/setSelectedChartTag", tag); //.('app/setSelected', data);

                this.$router.push({ name: "Charts" });
                
            },
            isTagHidden(tag){

                if(this.loggingOnly && !tag.logging){
                    return true ;
                }

                return false ;

            }
            
        },
        created() {

            // check if this user has rights to write this tag.

            this.unitTypes = helpers.get_unitTypes(); 
            
            let _this = this ; 

            let deviceSearch = this.devices.filter(function( obj ) {
                return obj.id === parseInt(_this.device_id) ;
            });

            this.device = deviceSearch[0] ;
            
            // Get tags
            this.device.db.collection('tags').orderBy("name").onSnapshot(function(querySnapshot) {

                querySnapshot.forEach(function(doc) {

                    let tag = doc.data() ;
                    tag.id = doc.id ; 

                    let tagIndex = _this.tags.findIndex(function( obj ) {
                        return obj.id === doc.id;
                    });

                    if(tagIndex !== -1){
                        _this.tags.splice(tagIndex, 1, tag) ;
                    }else{
                        _this.tags.push(tag) ;
                    }

                });

            });

            // Get alarms
            this.device.db.collection('alarms').orderBy("name").onSnapshot(function(querySnapshot) {

                querySnapshot.forEach(function(doc) {

                    let alarm = doc.data() ;
                    alarm.id = doc.id ; 

                    let alarmIndex = _this.alarms.findIndex(function( obj ) {
                        return obj.id === doc.id;
                    });

                    if(alarmIndex !== -1){
                        _this.alarms.splice(alarmIndex, 1, alarm) ;
                    }else{
                        _this.alarms.push(alarm) ;
                    }

                });

            });
            
        }
                
    }

</script>